export const getBrandAndMarketCamp = (type, brands, deckData, market) => {
  let obj = {
    brand: "",
    market: "",
    campaign: "",
  };
  if (type === "brand") {
    let brandName = brands?.find((item) => item._id === deckData?.brand);
    return (obj.brand = brandName?.name);
  } else if (type === "market") {
    let marketName = market?.find((item) => item._id === deckData?.market);
    return (obj.market = marketName?.name);
  } else if (type === "campaign") {
    let filterdCampaign = brands.filter(
      (item) => item?._id == deckData?.brand
    )[0]?.campaigns;
    if (filterdCampaign && filterdCampaign.length > 0) {
      let compainName = filterdCampaign?.find(
        (item) => item?._id === deckData?.campaign
      );
      return (obj.campaign = compainName?.name);
    }
  }
};
export const toggleLeftPanel = () => {
  const blockContainer = document?.querySelector("#blocks");
  const styleContainer = document?.querySelector("#stylesMangerBlock");
  const traitsContainer = document?.querySelector("#traitBlock");
  const backButton = document?.querySelector("#backToBlocks");
  const hideStructureBlock = document?.querySelector(".gjs-blocks-c");
  hideStructureBlock?.classList.add("d-none");

  const showOtherBlock = document?.querySelector(".gjs-blocks-no-cat");
  showOtherBlock?.classList.remove("d-none");
  blockContainer?.classList.remove("d-none");
  styleContainer?.classList.remove("d-block");
  // traitsContainer.classList.remove("d-block");
  backButton?.classList?.add("test-block");
};

const statusValues = [
  "DRAFT",
  "NOT SUBMITTED",
  "REVIEWED WITH MINOR CHANGES",
  "APPROVED WITH MINOR CHANGES",
];
export const isDeckEditable = (deckData, currentUserId) => {
  let docstatus = false;
    docstatus = statusValues?.includes(
      deckData?.veevaMetadata
        ?.filter((asset) => asset?.assetType === 1)[0]
        ?.docStatus.toUpperCase()
    );

  return (
    docstatus &&
    !deckData.expired &&
    (
      deckData?.created?.userid === currentUserId ||
      !deckData.locked
    )
  );
}
